import styled from 'styled-components'

export const HeroTextContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  border-radius: 4px;
  margin: 0 24px;
  color: #202020;
`

export const LabelText = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  margin-left: 32px;
  color: #202020;
`

export const TwoStepMultiSelectLabelContainer = styled.div`
  display: flex;
  align-items: center;
`
export const Divider = styled.div`
  height: 72px;
  width: 1px;
  background-color: rgba(32, 32, 32, 0.1);
`
